const { ThemeType, AuthServiceProviderType } = require("../constants");

const truthy = (val) => ['1', 'y', 'true'].includes(typeof val == 'number' ? val.toString() : (val || '').toLowerCase());

/**仅支持本地配置，可直接使用 */
const localConfig = {
    publicUrl: process.env.PUBLIC_URL,
    appName: process.env.REACT_APP_NAME,
    obtApiUrl: process.env.REACT_APP_OBT_API_URL,
    obtApiVersion: process.env.REACT_APP_OBT_API_VERSION,
    obtApiToken: process.env.REACT_APP_OBT_API_TOKEN,
    obtApiClientId: process.env.REACT_APP_OBT_API_CLIENT_ID,
    authServiceProviderType: AuthServiceProviderType[process.env.REACT_APP_AUTH_SERVICE_PROVIDER_TYPE],
}

let _appConfig;

/**合并本地和API配置，本地配置优先 */
const initConfig = (apiConfig) => {

    const config = {
        publicUrl: process.env.PUBLIC_URL,
        appName: process.env.REACT_APP_NAME,
        obtApiUrl: process.env.REACT_APP_OBT_API_URL,
        obtApiVersion: process.env.REACT_APP_OBT_API_VERSION,
        obtApiToken: process.env.REACT_APP_OBT_API_TOKEN,
        obtApiClientId: process.env.REACT_APP_OBT_API_CLIENT_ID,
        authServiceProviderType: AuthServiceProviderType[process.env.REACT_APP_AUTH_SERVICE_PROVIDER_TYPE],

        isDebug: process.env.NODE_ENV === 'development' || truthy(process.env.REACT_APP_IS_DEBUG || `${apiConfig.IsDebug}`),
        enableAuthMultiLanguage: truthy(process.env.REACT_APP_ENABLE_AUTH_MULTI_LANGUAGE || `${apiConfig.EnableAuthMultiLanguage}`),
        version: process.env.REACT_APP_VERSION || apiConfig.Version,
        obtUrl: process.env.REACT_APP_OBT_URL || apiConfig.ObtUrl,
        localhostUrl: process.env.REACT_APP_LOCALHOST_URL || apiConfig.LocalhostUrl,
        serviceTimeout: process.env.REACT_APP_SERVICE_TIMEOUT ? parseInt(process.env.REACT_APP_SERVICE_TIMEOUT) : apiConfig.ServiceTimeout,

        authDomain: process.env.REACT_APP_AUTH_DOMAIN || apiConfig.AuthDomain,
        authClientID: process.env.REACT_APP_AUTH_CLIENT_ID || apiConfig.AuthClientID,
        authRedirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI || apiConfig.AuthRedirectUri,
        authExternalLinkKey: process.env.REACT_APP_AUTH_EXTERNAL_LINK_KEY || apiConfig.AuthExternalLinkKey,
        authType: ['authing', '1'].includes(`${process.env.REACT_APP_AUTH_TYPE || apiConfig.AuthType}`.toLowerCase()) ? 'Authing' : 'Auth0',
        mapboxToken: process.env.REACT_APP_MAPBOX_TOKEN || apiConfig.MapboxToken,
        mapboxDarkStyle: process.env.REACT_APP_MAPBOX_DARK_STYLE || apiConfig.MapboxDarkStyle,
        mapboxLightStyle: process.env.REACT_APP_MAPBOX_LIGHT_STYLE || apiConfig.MapboxLightStyle,
        signalRHubUrl: process.env.REACT_APP_SIGNALR_HUB_URL || apiConfig.SignalRHubUrl,
        resetPasswordRoute: process.env.REACT_APP_RESET_PASSWORD_ROUTE || apiConfig.ResetPasswordRoute,
        externalSsoIdentifier: process.env.REACT_APP_EXTERNAL_SSO_IDENTIFIER || apiConfig.ExternalSsoIdentifier,
        invoicePageSize: process.env.REACT_APP_INVOICE_PAGE_SIZE ? parseInt(process.env.REACT_APP_INVOICE_PAGE_SIZE) : apiConfig.InvoicePageSize,
    }
    _appConfig = config;
    return config;
};
module.exports = {
    localConfig,
    initConfig,
    config: new Proxy({}, {
        get(_, key) {
            if (!_appConfig) {
                throw new Error('Can not read config before initialized');
            }
            return _appConfig[key];
        },
    }),
}